import type { ExceptionWeights } from "@/enums/exceptions/exception-weights"
import { useAlertStore } from "@/store/alert.store"
import { AlertTypes } from "@/interfaces/component/alert.interface"
import { isAcceptanceEnvironment, isProductionEnvironment } from "@/helper/app/browser-helper"

export abstract class BaseException {
  abstract exceptionId: string
  abstract title: string
  abstract weight: ExceptionWeights

  public abstract getMessage(): string

  public getTitle(): string {
    return this.title
  }

  public throw() {
    const message = this.getMessage()
    const alertStore = useAlertStore()
    alertStore.addAlert({
      type: AlertTypes.ERROR,
      title: this.title,
      body: message,
      lifetime: isProductionEnvironment() || isAcceptanceEnvironment() ? 0 : 5000
    })
    throw new Error(message)
  }
}
